var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.254902%,79.215686%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 21.148438 18.511719 C 17.5 20.152344 13.21875 18.53125 11.582031 14.890625 C 10.300781 12.046875 11.019531 8.808594 13.132812 6.75 C 12.65625 6.867188 12.183594 7.027344 11.722656 7.238281 C 7.488281 9.140625 5.597656 14.101562 7.496094 18.324219 C 9.394531 22.546875 14.363281 24.425781 18.59375 22.527344 C 20.976562 21.453125 22.617188 19.410156 23.257812 17.074219 C 22.660156 17.660156 21.953125 18.152344 21.148438 18.511719 Z M 21.148438 18.511719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.254902%,79.215686%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 18.953125 10.777344 L 18.789062 11.90625 L 19.863281 12.460938 L 18.6875 12.609375 L 18.523438 13.738281 L 17.960938 12.699219 L 16.785156 12.84375 L 17.613281 12.054688 L 17.050781 11.011719 L 18.125 11.566406 Z M 18.953125 10.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.254902%,79.215686%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 18.929688 15.5625 L 18.933594 16.1875 L 19.554688 16.402344 L 18.933594 16.574219 L 18.9375 17.195312 L 18.546875 16.679688 L 17.925781 16.851562 L 18.308594 16.359375 L 17.921875 15.84375 L 18.546875 16.054688 Z M 18.929688 15.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.254902%,79.215686%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 14.414062 9.414062 L 14.511719 10.019531 L 15.128906 10.121094 L 14.570312 10.394531 L 14.667969 11 L 14.226562 10.5625 L 13.671875 10.839844 L 13.957031 10.292969 L 13.515625 9.859375 L 14.128906 9.957031 Z M 14.414062 9.414062 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1);
export default __webpack_public_path__ + "static/media/m1.de37fa892204e78a9c8aee5f76ea3227.svg";
export { ForwardRef as ReactComponent };